<script setup lang="ts">
import { ref } from "vue";
import { RegistrationChannel } from "@/shared/@types/RegistrationChannel";
import gasShopRegistrationImage from "@/shared/images/gas-shop-registration.webp";
import RequestInviteScreen from "@/app/registration-app/shared/components/RequestInviteScreen/RequestInviteScreen.vue";
import RegistrationWizardContainer from "@/app/registration-app/user/shared/containers/RegistrationWizardContainer/RegistrationWizardContainer.vue";

// --- Request Invite ---
const isRequestInviteVisible = ref(false);

const showRequestInvite = () => (isRequestInviteVisible.value = true);
const changeCustomerNumber = () => (isRequestInviteVisible.value = false);

// TODO: notify the responsible Account Managers once the process is defined
const requestInvite = () => {};
</script>

<template>
  <RequestInviteScreen
    v-if="isRequestInviteVisible"
    :image="gasShopRegistrationImage"
    @request-invite="requestInvite"
    @change-customer-number="changeCustomerNumber"
  />
  <RegistrationWizardContainer
    v-else
    :title="$t('registration.user.gasShop.title')"
    :text="$t('registration.user.gasShop.text')"
    :channel="RegistrationChannel.Gas"
    :image="gasShopRegistrationImage"
    @request-invite="showRequestInvite"
  />
</template>
